import React from "react";
import TBBImage from "utils/TBBImage";
import TBBLink from "utils/TBBLink";
import Button from "utils/Button";

const WorkTwoColumnCardsItems = ({ postsToRender }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2">
      {postsToRender.map((post) => (
        <TBBLink key={post.uuid} to={post.full_slug} className="relative">
          <TBBImage
            image={post.content.featured_image}
            className="w-[calc(100%+1px)]"
          />
          {/*<div className="absolute w-full h-full inset-0 flex justify-end items-end z-10 text-[#fff] p-6 text-2xl">
                        {post.name}
            </div> */}
          <Button className="absolute top-0 left-0 ml-2 h-full w-full !items-end !justify-start"></Button>
        </TBBLink>
      ))}
    </div>
  );
};
export default WorkTwoColumnCardsItems;
